// extracted by mini-css-extract-plugin
export default {"content":"CenterMobileIRepairMobile_content__TSDmU","emaillink":"CenterMobileIRepairMobile_emaillink__i8ShD"};